import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"

import {
  fetchResortsContent,
  updateResortsContent,
} from "./resorts-content.service"

const RESORTS_CONTENT_QUERY_KEY = ["resorts-content"]

export const useResortsContentQuery = () => {
  const query = useQuery({
    queryKey: RESORTS_CONTENT_QUERY_KEY,
    queryFn: fetchResortsContent,
  })

  return {
    content: query.data?.content || null,
    contents: query.data?.contents || [],
    contentId: query.data?.content?.id || null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  }
}

export const useUpdateResortsContentMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, data }) => updateResortsContent(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: RESORTS_CONTENT_QUERY_KEY })
    },
  })
}